var modules_2fd5ce57 = {"arrows":"_rbrfy","important":"_sgmeaw","button":"_1omvizr","icon":"_1rjg429"};
import "../../../assets/Bx4HDcO8.css";

export { modules_2fd5ce57 as default };
//# sourceMappingURL=Arrows.module.less.js.map
